import React, { useEffect, useState } from 'react'
import { store } from './redux/store'
import { useSelector } from 'react-redux'
import { Button } from '@mui/material'
export default function Download(props) {
  const [favs,setFavs]=useState()
  const [shpcopied,setshpcopied]=useState("copy keyframes")
  const [mapData,setMapData]=useState(store.getState().red1.favdata.map(str => str.replace(/-/g, '_')))
  const mysel=useSelector(state=>state.red1.filtered)
  useEffect(()=>{
    setFavs(store.getState().red1.favdata.map((items)=><span className='fabelm'>{items}</span>))
  },[props.dwTgl])

  useEffect(()=>{
    setMapData(store.getState().red1.favdata.map(str => str.replace(/-/g, '_')))
  },[store.getState().red1.favdata])
  
  const download=()=>{
    const blob= new Blob([document.getElementById('shapeDLD').value.replace(/,/g,'\n'),{type:'text/css'}])
    const blobURL=window.URL.createObjectURL(blob)
    const elem=document.createElement("a")
    elem.href=blobURL
    elem.download='style_keyframes.css'
    elem.click()
    window.URL.revokeObjectURL(blobURL)
  }
  return (
    <div className='flex-center download' id='downloadid'>
      <div className='downloadBox' id='storage'>
        <h3>Here are your fav picks....</h3>
        <div className='fabs flex flexWrap'>
          {favs}
        </div>
      </div>
      <textarea className="downloadBox" id="shapeDLD" spellCheck="false" autoCapitalize="none" autoCorrect="off" autoComplete="off" wrap="off" readOnly="" value={mapData.map(items=>{return store.getState().red1.favkfrs[items]})}></textarea>
      <div className='downloadBox' id='keyframesDLD'>
      <Button id='copybtn4' variant='contained' size='small'  onClick={()=>{navigator.clipboard.writeText(document.getElementById('shapeDLD').value);setshpcopied("copied");setTimeout(()=>{setshpcopied("copy keframes")}, 1500);}} >{shpcopied}</Button>
      <Button id='copybtn5' variant='contained' size='small' onClick={download}>Download</Button>
      </div>
    </div>
  )
}
